import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import type {
  FeedbackResponse,
  FeedbackResponseDTO,
} from '../interfaces/feedback-response';
import { hostsConfig } from '../utils';

export default abstract class LiveClassFeedbackDao {
  static async getLiveClassFeedbacks(
    env: Environment,
    contactId: string,
    pageSize = 3,
    pageIndex = 1
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.get<FeedbackResponse>(
      `${url}/v1/liveclassfeedbacks`,
      {
        params: { contactId, pageSize, pageIndex },
      }
    );

    return data.feedbackResponseDTOs;
  }

  static async getLiveClassFeedbackByUUID(
    env: Environment,
    feedbackUUID: string
  ) {
    const url = hostsConfig[env].courseServiceHost;
    const { data } = await axios.get<FeedbackResponseDTO>(
      `${url}/v1/liveclassfeedbacks/uuid/${feedbackUUID}`
    );

    return data;
  }
}
